var _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDealers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_1754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 33C1 15.3269 15.3269 1 33 1C50.6731 1 65 15.3269 65 33C65 50.6731 50.6731 65 33 65C15.3269 65 1 50.6731 1 33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 29H35V43H50V29Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 29H35V43H50V29Z",
    fill: "#555555",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 34H27V48H42V34Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 34H26V48H41V34Z",
    fill: "#555555",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7981 30.5295H-19.646V50.2126H1.7981V30.5295Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.149 50H-22.149C-26.485 50 -30 51.567 -30 53.5C-30 55.433 -26.485 57 -22.149 57H63.149C67.485 57 71 55.433 71 53.5C71 51.567 67.485 50 63.149 50Z",
    fill: "#E6EBEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80025 28.063C8.80025 28.063 -6.45185 45.5338 4.78405 51.3788C12.5499 55.4181 21.1842 49.8512 21.1842 49.8512L8.80025 28.063Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M7.80025 30.063C7.80025 30.063 -7.45185 47.5338 3.78405 53.3788C11.5499 57.4181 20.1842 51.8512 20.1842 51.8512L7.80025 30.063Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7864 26.3888L16.1304 20.578C16.1304 20.578 16.5604 16.8468 18.4266 17.5228C20.2928 18.1989 22.2579 21.8702 21.2474 23.0127C20.7013 23.6288 20.1294 23.2523 19.3941 23.3208C18.762 23.3807 18.8738 23.2865 18.8738 23.9155V26.132L15.7864 26.3888Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5362 26.3413C16.5362 26.3413 6.44486 25.2998 5.12683 33.1922C3.80879 41.0846 13.1984 56 13.1984 56L26.2823 55.4104C26.2823 55.4104 46.6135 22.3047 16.5362 26.3413Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M24.2261 29.2556C24.2261 29.2556 15.166 34.6984 19.6122 42.9867C22.4674 48.3054 15.166 55.3955 15.166 55.3955L25.2065 55.0062C25.2065 55.0062 28.8873 49.5762 29.6226 47.4624C30.3579 45.3486 24.2261 29.2556 24.2261 29.2556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0535 55.5718L6.61353 85.2119H9.98043L17.5011 61.4211L25.9764 85.2162H29.8335L25.211 54.9856L10.0535 55.5718Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4783 23.5826H17.3015C17.3015 23.5826 17.6971 20.2322 18.9871 19.5904C20.2771 18.9485 21.5671 17.7376 20.419 16.6294C19.2709 15.5211 17.6455 14.2417 15.7363 15.5596C13.8271 16.8775 13.152 20.0525 15.4783 23.5826Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0153 18.4623L23 19L21.8628 17.1442C21.8628 17.1442 21.2426 12.7901 18.9682 12.1429C16.6939 11.4957 12.7224 12.9519 13.0153 18.4623Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 26H40V50H66V26Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M56 26H51V33H56V26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 42H58V47H63V42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2615 31.5226C22.627 28.1765 26.3594 26.2381 29.249 27.9925C31.2743 29.2205 33.2953 31.3728 34.409 35.1211C36.559 42.4638 35.5055 46.8111 49.889 47.0294V50.9617C49.889 50.9617 19.3332 58.3557 22.2615 31.5226Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M22.2615 31.5226C22.627 28.1765 26.3594 26.2381 29.249 27.9925C31.2743 29.2205 33.2953 31.3728 34.409 35.1211C36.559 42.4638 35.5055 46.8111 49.889 47.0294V50.9617C49.889 50.9617 19.3332 58.3557 22.2615 31.5226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8726 47.7423C49.8726 47.7423 53.6221 47.2117 53.9876 48.3028C54.3531 49.3939 54.0994 50.4808 49.8726 50.1556V47.7423Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9417 55.5713H52.8176V86.4394H63.9417V55.5713Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M60.1837 61.3311C62.2593 61.3311 63.9419 59.6568 63.9419 57.5913C63.9419 55.5259 62.2593 53.8516 60.1837 53.8516C58.1081 53.8516 56.4255 55.5259 56.4255 57.5913C56.4255 59.6568 58.1081 61.3311 60.1837 61.3311Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 64C15.8792 64 2 50.1208 2 33H0C0 51.2254 14.7746 66 33 66V64ZM64 33C64 50.1208 50.1208 64 33 64V66C51.2254 66 66 51.2254 66 33H64ZM33 2C50.1208 2 64 15.8792 64 33H66C66 14.7746 51.2254 0 33 0V2ZM33 0C14.7746 0 0 14.7746 0 33H2C2 15.8792 15.8792 2 33 2V0Z",
    fill: "#E6EBEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_1754"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 33C1 15.3269 15.3269 1 33 1C50.6731 1 65 15.3269 65 33C65 50.6731 50.6731 65 33 65C15.3269 65 1 50.6731 1 33Z",
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealers);
export default __webpack_public_path__ + "static/media/Dealers.ab0433fe.svg";
export { ForwardRef as ReactComponent };